// Calculează starea unei date de expirare pentru semaforul vizual.
// verde = ok (>30 zile), galben = expiră curând (0-30 zile), rosu = expirat.
// Robust la formate diverse de dată venite din Excel/LeaseinDAC.

// Încearcă să interpreteze o dată din mai multe formate posibile.
// Returnează un obiect Date valid sau null.
function parseData(val) {
  if (!val) return null;
  if (val instanceof Date) return isNaN(val) ? null : val;

  const s = String(val).trim();
  if (!s) return null;

  // Format ISO: 2027-11-04 sau 2027-11-04T...
  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) {
    const d = new Date(+m[1], +m[2] - 1, +m[3]);
    return isNaN(d) ? null : d;
  }

  // Format românesc cu puncte sau slash: 04.11.2027 / 04/11/2027 / 4-11-2027
  m = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
  if (m) {
    const d = new Date(+m[3], +m[2] - 1, +m[1]);
    return isNaN(d) ? null : d;
  }

  // Doar an: 2027 -> considerăm 31 decembrie acel an
  m = s.match(/^(\d{4})$/);
  if (m) {
    const d = new Date(+m[1], 11, 31);
    return isNaN(d) ? null : d;
  }

  // Ultimă încercare: lăsăm JS să încerce (ex. formate cu nume de lună)
  const d = new Date(s);
  return isNaN(d) ? null : d;
}

export function statusExpirare(val) {
  const data = parseData(val);
  if (!data) return { stare: "necunoscut", zile: null };

  const azi = new Date();
  azi.setHours(0, 0, 0, 0);
  const zile = Math.round((data - azi) / (1000 * 60 * 60 * 24));

  if (zile < 0) return { stare: "rosu", zile };
  if (zile <= 30) return { stare: "galben", zile };
  return { stare: "verde", zile };
}

// Formatează o dată în format românesc (zz.ll.aaaa). Dacă nu e validă, "—".
export function formatData(val) {
  const d = parseData(val);
  if (!d) return "—";
  const zz = String(d.getDate()).padStart(2, "0");
  const ll = String(d.getMonth() + 1).padStart(2, "0");
  return `${zz}.${ll}.${d.getFullYear()}`;
}

// Text scurt pentru starea de expirare.
export function textStare(zile) {
  if (zile === null || zile === undefined || isNaN(zile)) return "nespecificat";
  if (zile < 0) return `expirat de ${Math.abs(zile)} zile`;
  if (zile === 0) return "expiră azi";
  if (zile === 1) return "expiră mâine";
  if (zile <= 30) return `expiră în ${zile} zile`;
  return `valabil ${zile} zile`;
}
